import { render } from "./CourseDrawer.vue?vue&type=template&id=7e67ea8f&scoped=true"
import script from "./CourseDrawer.vue?vue&type=script&lang=js"
export * from "./CourseDrawer.vue?vue&type=script&lang=js"

import "./CourseDrawer.vue?vue&type=style&index=0&id=7e67ea8f&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e67ea8f"]])

export default __exports__